import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import '../styles/vue.styl'
import de from 'vuetify/es5/locale/de'

Vue.use(Vuetify, {
  theme: {
    primary: '#1AA766',
    secondary: '#436EF1',
    accent: '#EB5056',
    error: '#EB5056',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FFC107'
  },
  options: {
    customProperties: true
  },
  iconfont: 'md',
  lang: {
    locales: { de },
    current: 'de'
  },
})
